import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import { useApi } from "../../../../hooks/useApi";
import ToggleBtn from "../../../Button/ToggleBtn";
import LineBox from "../../../DefaultStyles/LineBox";
import Loader from "../../../DefaultStyles/Loader";
import AlertModal from "../../../Modal/AlertModal";
import ManagerPwInputModal from "../../../Modal/ManagerPwInputModal";
import Table, { TableBody, TableBodyItem } from "../../../Table/Table";
import MaintenanceTimeModal from "./ManageServer/MaintenanceTimeModal";
import { OptionType } from "../../../Filters/DropDown";
import LineBtn from "../../../Button/LineBtn";

interface IServer {
  maintenance: string;
  admin?: string;
  lastupdate?: string;
}

interface ManageServerProps {
  serverData?: IServer;
  refetch: () => void;
}

export default function ManageServer({
  serverData,
  refetch,
}: ManageServerProps) {
  const [isMaintenance, setIsMaintenance] = useState(
    serverData?.maintenance === "0" ? false : true
  ); // 점검 중인지
  const [askModal, setAskModal] = useState(false);
  const [pwInputModal, setPwInputModal] = useState(false);
  const [endDate, setEndDate] = useState("선택"); // 점검 종료 날짜
  const [hourDropdownValue, setHourDropdownValue] = useState<OptionType>({
    value: "",
    label: "시",
  }); // 점검 종료 시
  const [minuteDropdownValue, setMinuteDropdownValue] = useState<OptionType>({
    value: "",
    label: "분",
  }); // 점검 종료 분
  const [updateMaintenance, setUpdateMaintenance] = useState(false); // 서버 점검 업데이트 실행
  const [maintenanceTimeModal, setMainTenanceTimeModal] = useState(false);
  const [isChangeTime, setIsChangeTime] = useState(false); // 점검 일시 업데이트 위함인지

  const tableHead = [
    "상태",
    "담당자",
    "점검 일시",
    "최근 업데이트 일시",
    "점검 ON/OFF",
    isMaintenance ? "점검 일시 업데이트" : undefined,
  ];

  // 서버 점검 상태 업데이트 하기
  const { response, error, loading } = useApi({
    method: "post",
    url: updateMaintenance ? `version/maintenance` : undefined,
    data: {
      maintenance:
        !isMaintenance || isChangeTime // 점검 중이 아니거나 점검 시간 업데이트
          ? `${endDate} ${hourDropdownValue?.value}:${minuteDropdownValue?.value}:00` // 점검 시간
          : "0", // 점검 종료
    },
  });

  useEffect(() => {
    if (response?.status === 200 || response?.status === 201) {
      setIsMaintenance(!isMaintenance || isChangeTime ? true : false);
      toast.success(
        !isMaintenance
          ? "서버 점검을 시작합니다."
          : isChangeTime
          ? "서버 점검 시간을 업데이트 했습니다."
          : "서버 점검을 종료합니다."
      );
      setUpdateMaintenance(false);
      setIsChangeTime(false);
      refetch();
    }
  }, [response]);

  useEffect(() => {
    if (error) {
      toast.error(
        error?.data ?? "서버 점검 상태를 업데이트 하는 데에 실패하였습니다."
      );
    }
  }, [error]);

  useEffect(() => {
    setIsMaintenance(serverData?.maintenance === "0" ? false : true);
  }, [serverData]);

  useEffect(() => {
    console.log(updateMaintenance, isMaintenance, isChangeTime);
  }, [updateMaintenance]);

  return (
    <>
      <LineBox>
        <Table tableHeadData={tableHead}>
          <>
            <TableBody>
              <TableBodyItem>{isMaintenance ? "점검중" : "정상"}</TableBodyItem>
              <TableBodyItem>{serverData?.admin}</TableBodyItem>
              <TableBodyItem>
                {serverData?.maintenance === "0"
                  ? "-"
                  : dayjs(serverData?.maintenance ?? undefined)?.format(
                      "YYYY-MM-DD HH:mm:ss"
                    )}
              </TableBodyItem>
              <TableBodyItem>
                {dayjs(serverData?.lastupdate ?? undefined)?.format(
                  "YYYY-MM-DD HH:mm:ss"
                )}
              </TableBodyItem>
              <TableBodyItem>
                <ToggleBtn
                  check={isMaintenance}
                  checkEvent={() => {
                    if (isMaintenance) {
                      setAskModal(true);
                    } else {
                      setMainTenanceTimeModal(true);
                    }
                  }}
                />
              </TableBodyItem>
              {serverData?.maintenance !== "0" && (
                <TableBodyItem>
                  <LineBtn
                    btnText="업데이트"
                    btnClickEvent={() => {
                      setIsChangeTime(true);
                      setMainTenanceTimeModal(true);
                    }}
                  />
                </TableBodyItem>
              )}
            </TableBody>
          </>
        </Table>
      </LineBox>

      {loading && <Loader />}

      {askModal && (
        <AlertModal
          title={`서버 점검을 ${isMaintenance ? "종료합니다." : "시작합니다."}
        계속 하시겠습니까?`}
          cancelEvent={() => setAskModal(false)}
          confirmEvent={() => {
            setPwInputModal(true);
            setAskModal(false);
          }}
        />
      )}

      {/* 서버 점검 종료 시간 설정 */}
      {maintenanceTimeModal && (
        <MaintenanceTimeModal
          closeEvent={() => setMainTenanceTimeModal(false)}
          confirmEvent={() => {
            setPwInputModal(true);
            setMainTenanceTimeModal(false);
          }}
          endDate={endDate}
          setEndDate={setEndDate}
          hourDropdownValue={hourDropdownValue}
          setHourDropdownValue={setHourDropdownValue}
          minuteDropdownValue={minuteDropdownValue}
          setMinuteDropdownValue={setMinuteDropdownValue}
        />
      )}

      {/* 관리자 비밀번호 입력 */}
      {pwInputModal && (
        <ManagerPwInputModal
          closeEvent={() => setPwInputModal(false)}
          confirmEvent={() => {
            setUpdateMaintenance(true);
            setPwInputModal(false);
          }}
          confirmBtnText={isMaintenance ? "서버 점검 종료" : "서버 점검 시작"}
        />
      )}
    </>
  );
}
